import * as React from 'react';
import { useGeocoder } from '@ttoss/google-maps';

type MapGeocoderResult = google.maps.GeocoderResult;
type MapGeocoderStatus = google.maps.GeocoderStatus;

export type LatLng = {
  lat: number;
  lng: number;
};

export const useGeocoding = () => {
  const { geocoder } = useGeocoder();

  const getLatLong = React.useCallback(
    ({ address }: { address: string }): Promise<LatLng> => {
      return new Promise((resolve, reject) => {
        if (!geocoder) {
          return reject(new Error('Geocoder not defined'));
        }

        geocoder.geocode(
          { address },
          (results: MapGeocoderResult[] | null, status: MapGeocoderStatus) => {
            if (results && status === window.google.maps.GeocoderStatus.OK) {
              const lat = results[0].geometry.location.lat();
              const lng = results[0].geometry.location.lng();

              return resolve({
                lat,
                lng,
              });
            } else {
              // eslint-disable-next-line no-console
              console.error(
                'Geocode was not successful for the following reason: ',
                status
              );
              return reject(new Error('Result not found'));
            }
          }
        );
      });
    },
    [geocoder]
  );

  const getAddress = React.useCallback(
    (location: LatLng, allResults?: boolean) => {
      return new Promise((resolve, reject) => {
        if (!geocoder) {
          return reject(new Error('Geocoder not defined'));
        }

        geocoder.geocode(
          { location },
          (results: MapGeocoderResult[] | null, status: MapGeocoderStatus) => {
            if (results && status === window.google.maps.GeocoderStatus.OK) {
              if (allResults) {
                return resolve(results);
              }

              return resolve(results[0].formatted_address);
            } else {
              // eslint-disable-next-line no-console
              console.error(
                'Geocode was not successful for the following reason: ',
                status
              );
              return reject(new Error('Result not found'));
            }
          }
        );
      });
    },
    [geocoder]
  );

  return { getLatLong, getAddress };
};
